import { I18n } from '@front/volcanion'

class Callbacks {

  static afterVoucherChangeHandler(setFormValues, setFormState, searchVoucher, isB2B) {
    return async function afterVoucherChange(code) {
      if (!!code && code.length >= 4) {
        const [voucher] = await searchVoucher({ code }, { single: true })

        if (!voucher) {
          setFormState({ voucher_id: null })
        } else if (!voucher?.companyservice) {
          setFormState({ voucher_id: voucher?.voucher_id })
          setFormValues([
            { field: 'voucher', meta: { error: false } }
          ])
        } else if (!isB2B) {
          setFormState({ isB2B: true, voucher_id: voucher?.voucher_id })
          setFormValues([
            { field: 'voucher', meta: { error: false } }
          ])
        } else {
          setFormState({ voucher_id: voucher?.voucher_id })
          setFormValues([
            { field: 'user.companyservice', value: voucher?.companyservice?.companyservice_id },
            { field: 'user.companycontract', value: voucher?.companyservice?.contract },
            { field: 'voucher', meta: { error: false } }
          ])
        }
      }
    }
  }

  static validateVoucherHandler(voucher_id) {
    return function validateVoucher(code) {
      if (!!code && code.length >= 6 && !voucher_id) {
        return I18n.t('voucher.error.invalid')
      }
      return null
    }
  }
}


export default Callbacks
